import { IconThreeColumnsImageText } from '@hivebrite/design-system/Icon';

const ThreeColumnsImageText = () => <div />; // never used

ThreeColumnsImageText.componentName = 'ThreeColumnsImageText';
ThreeColumnsImageText.componentType = 'section';

ThreeColumnsImageText.componentCategory = 'predefined-structure';
ThreeColumnsImageText.componentIcon = () => IconThreeColumnsImageText;

ThreeColumnsImageText.canBeDoubleClicked = true;
ThreeColumnsImageText.canBeDragged = true;
ThreeColumnsImageText.canBeListed = true;
ThreeColumnsImageText.canBeSelected = true;

ThreeColumnsImageText.item = ({
  bodyWidth,
  components,
  features,
  featureFlags,
  theme,
}) => {
  const { Column, Section, Text, ...rest } = components;
  const Image = rest?.EmailImage || rest?.PageImage;

  const nbColumns = 3;

  const children = () => [
    Image.item({ featureFlags }),
    Text.item({
      features,
      theme,
    }),
  ];

  return Section.item({
    children: Array(nbColumns)
      .fill()
      .map(() =>
        Column.item({
          children: children(),
          width: `${100 / nbColumns}%`,
        }),
      ),
    features: {
      ...features,
      section: {
        ...features?.section,
        name: ThreeColumnsImageText.componentName,
        sectionWidth: bodyWidth,
      },
    },
  });
};

export default ThreeColumnsImageText;
